import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import Helper from '../../Helper/Helper';
import HelperDate from '../../Helper/HelperDate';
import { DiplomaService } from '../../services';
import Modal from '../Modal';
import AnulacaoHistorico from './AnulacaoHistorico';

import './styles.scss';

const DiplomaValidacao = ({ diplomaId, codigoVerificador, diploma, showDownloadXml, exibirCampos = false }) => {
    const [loadingRvvd, setLoadingRvvd] = useState(false);
    const [loadingXml, setLoadingXml] = useState(false);
    const [cpfMascara, setCpfMascara] = useState();

    function mascaraCpf() {
        const cpf = Helper.cpfMask(xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.CPF);
        const replace = 'xxx' + cpf.slice(3);
        setCpfMascara(replace.replace(cpf.slice(-2), 'xx'));
    }

    useEffect(() => {
        if(diploma?.ativo)
            mascaraCpf();
    }, [])

    function downloadRvvd() {
        setLoadingRvvd(true);
        const request = diplomaId ? DiplomaService.getRvvdToDownload(diplomaId) : DiplomaService.getRvvdToDownloadByCodigoVerificador(codigoVerificador);
        return request.then(
            result => {
                if (result === null) {
                    toast.warn('Rvdd indisponível no momento, tente novamente mais tarde!')
                    return;
                }
                Helper.openPdfNewTab(result);
                setLoadingRvvd(false);
            }, error => {
                const message = error?.response?.data?.data;
                toast.warn(message ? message : `Ocorreu um erro ao buscar o arquivo!`);
                setLoadingRvvd(false);
            });
    }

    function downloadXml() {
        setLoadingXml(true);
        return DiplomaService.getXmlToDownload(diplomaId).then(
            result => {
                let fileName = 'meu_diploma.xml';
                if (xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.Nome) {
                    fileName = `${xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.Nome}_Diploma.xml`
                }
                Helper.downloadFile(result, fileName);
                setLoadingXml(false);
            }, error => {
                const message = error?.response?.data?.data;
                toast.warn(message ? message : `Ocorreu um erro ao buscar o arquivo!`);
                setLoadingXml(false);
            });
    }

    function handleShowAnulacoes() {
        Modal.show('Visualizar anulações', <AnulacaoHistorico anulacoes={diploma?.anulacoes} />, false, true, null, { large: true });
    }

    const { xmlJson } = diploma;
    return (
        <div id="moduloLoginAluno" className="form-container col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="form-container-dados_diploma col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="conteudo-dados_diploma-cards col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

                    <div className="topo-dados_diploma-cards col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        {
                            diploma?.ativo &&
                            <>
                                <div className="dados_diploma-validado-icon">
                                </div>
                                <div className="topo-dados_diploma-descricao">
                                    <p>
                                        O Reitor do Centro Universitário Internacional UNINTER,
                                        no uso de suas atribuições e tendo em vista a conclusão do
                                        <span> {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.NomeCurso}</span> em
                                        <span> {HelperDate.formatOlyDate(diploma?.dataConclusao)}</span> e a Colação de Grau em
                                        <span> {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosRegistro?.LivroRegistro?.DataColacaoGrau)}</span>,
                                        confere o título de
                                        <span> {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.TituloConferido?.Titulo}
                                            {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.TituloConferido?.OutroTitulo}</span> a
                                        <span> {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.Nome}</span>,
                                        e outorga-lhe o presente Diploma Digital a fim de que possa gozar de todos os diretos e
                                        prerrogativas legais.
                                    </p>
                                </div>
                            </>
                        }
                        {
                            diploma?.anulado &&
                            <div className="dados_diploma-invalido-icon">
                            </div>
                        }
                    </div>

                    {
                        diploma?.anulado &&
                        <>
                            <h6 className="mt-4 diploma-anulado">Diploma Anulado!</h6>
                            <AnulacaoHistorico anulacoes={diploma?.anulacoes} />
                        </>
                    }


                    {
                        diploma?.ativo &&
                        <>
                            <div className="top-dados_diploma-cards-btn col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ms-2">
                                {
                                    showDownloadXml &&
                                    <button type="submit" onClick={() => downloadXml()} disabled={loadingXml}>
                                        <i className={`fas ${loadingXml ? 'fa-spinner fa-spin' : `fa-file-download`}`}></i>
                                        Baixar XML
                                    </button>
                                }

                                {
                                    !diploma?.primeiraVia &&
                                    <div className="segunda_via-diploma">
                                        <span>{diploma?.versao}ª versão</span> de Diploma
                                    </div>
                                }

                                <button type="submit" className="me-1" onClick={() => downloadRvvd()} disabled={loadingRvvd}>
                                    <i className={`fas ${loadingRvvd ? 'fa-spinner fa-spin' : `fa-file-download`}`}></i>
                                    Baixar Representação visual
                                </button>
                            </div>

                            <div className="uninter-diploma_digital-campos-box margin-top-0 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h3>Diplomado</h3>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <label htmlFor="Nome">
                                        Nome
                                    </label>
                                    <span id="Nome" className="campo_responsivo-height">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.Nome}
                                    </span>
                                </div>
                                {exibirCampos &&
                                    <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-2 col-lg-2 col-xl-1">
                                        <label htmlFor="Sexo">
                                            Sexo
                                        </label>
                                        <span id="Nome">
                                            {
                                                xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.Sexo === 'F' ?
                                                    <>{'F'}</>
                                                    :
                                                    <>{'M'}</>
                                            }
                                        </span>
                                    </div>
                                }


                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5">
                                    <label htmlFor="Nacionalidade">
                                        Nacionalidade
                                    </label>
                                    <span id="Nacionalidade">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.Nacionalidade}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-8 col-md-5 col-lg-6 col-xl-6">
                                    <label htmlFor="Naturalidade">
                                        Naturalidade
                                    </label>
                                    <span id="Naturalidade">
                                        <div id="NomeMunicipio">
                                            {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.Naturalidade?.NomeMunicipio}
                                            {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.Naturalidade?.NomeMunicipioEstrangeiro}
                                        </div>
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-2 col-lg-2 col-xl-1">
                                    <label htmlFor="UF">
                                        UF
                                    </label>
                                    <span id="UF">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.Naturalidade?.UF}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-3">
                                    <label htmlFor="CPF">
                                        CPF
                                    </label>
                                    <span id="CPF">
                                        {cpfMascara}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-10 col-lg-4 col-xl-4">
                                    <label htmlFor="OutroDocumentoIdentificacao">
                                        Documento de Identificação
                                    </label>
                                    <span id="OutroDocumentoIdentificacao" className="campo_responsivo-height">
                                        <div id="Identificador">
                                            {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.OutroDocumentoIdentificacao?.Identificador}
                                        </div>
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-4">
                                    <label htmlFor="DataNascimento">
                                        Data de Nascimento
                                    </label>
                                    <span id="DataNascimento">
                                        {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosDiploma?.Diplomado?.DataNascimento)}
                                    </span>
                                </div>

                            </div>

                            <div className="uninter-diploma_digital-campos-box col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h3>Dados do Curso</h3>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                                    <label htmlFor="CodigoCursoEMEC">
                                        Cód. Curso no EMEC
                                    </label>
                                    <span id="CodigoCursoEMEC">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.CodigoCursoEMEC}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <label htmlFor="NomeHabilitacao">
                                        Nome
                                    </label>
                                    <span id="NomeHabilitacao" className="campo_responsivo-height">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.NomeCurso}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <label htmlFor="NomeHabilitacao">
                                        Nome Habilitação
                                    </label>
                                    <span id="NomeHabilitacao">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.NomeHabilitacao}
                                    </span>
                                </div>

                                {exibirCampos &&
                                    <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-2 col-lg-2 col-xl-1">
                                        <label htmlFor="Modalidade">
                                            Modalidade
                                        </label>
                                        <span id="Modalidade">
                                            {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.Modalidade}
                                        </span>
                                    </div>
                                }

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5">
                                    <label htmlFor="TituloConferido">
                                        Título Conferido
                                    </label>
                                    <span id="TituloConferido">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.TituloConferido?.Titulo}
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.TituloConferido?.OutroTitulo}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5">
                                    <label htmlFor="GrauConferido">
                                        Grau Conferido
                                    </label>
                                    <span id="GrauConferido">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.GrauConferido}
                                    </span>
                                </div>

                                <div id="Autorizacao" className="uninter-diploma_digital-titulo_interno">
                                    Autorização
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-3">
                                    <label htmlFor="Tipo">
                                        Tipo
                                    </label>
                                    <span id="Tipo">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.Autorizacao?.Tipo}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-3 col-lg-2 col-xl-2">
                                    <label htmlFor="Numero">
                                        Número
                                    </label>
                                    <span id="Numero">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.Autorizacao?.Numero}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-4">
                                    <label htmlFor="Data">
                                        Data
                                    </label>
                                    <span id="Data">
                                        {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.Autorizacao?.Data)}
                                    </span>
                                </div>

                                <div id="Autorizacao" className="uninter-diploma_digital-titulo_interno">
                                    Reconhecimento
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-3">
                                    <label htmlFor="Tipo">
                                        Tipo
                                    </label>
                                    <span id="Tipo">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.Reconhecimento?.Tipo}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-3 col-lg-2 col-xl-2">
                                    <label htmlFor="Numero">
                                        Número
                                    </label>
                                    <span id="Numero">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.Reconhecimento?.Numero}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-4">
                                    <label htmlFor="Data">
                                        Data
                                    </label>
                                    <span id="Data">
                                        {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosDiploma?.DadosCurso?.Reconhecimento?.Data)}
                                    </span>
                                </div>

                            </div>

                            <div className="uninter-diploma_digital-campos-box col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h3>IES Emissora / Registradora</h3>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <label htmlFor="Nome">
                                        Nome
                                    </label>
                                    <span id="Nome" className="campo_responsivo-height">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Nome}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                                    <label htmlFor="CodigoMEC">
                                        Cód. MEC
                                    </label>
                                    <span id="CodigoMEC">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.CodigoMEC}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5">
                                    <label htmlFor="CNPJ">
                                        CNPJ
                                    </label>
                                    <span id="CNPJ">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.CNPJ}
                                    </span>
                                </div>

                                <div id="EnderecoCurso" className="uninter-diploma_digital-titulo_interno">
                                    Endereço do Curso
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10">
                                    <label htmlFor="Logradouro">
                                        Logradouro
                                    </label>
                                    <span id="Logradouro">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Endereco?.Logradouro}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-3 col-lg-2 col-xl-2">
                                    <label htmlFor="Numero">
                                        Número
                                    </label>
                                    <span id="Numero">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Endereco?.Numero}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-6 col-xl-6">
                                    <label htmlFor="Bairro">
                                        Bairro
                                    </label>
                                    <span id="Bairro">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Endereco?.Bairro}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-6 col-xl-6">
                                    <label htmlFor="Municipio">
                                        Município
                                    </label>
                                    <span id="Municipio">
                                        <div id="NomeMunicipio">
                                            {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Endereco?.NomeMunicipio}
                                        </div>
                                        <div id="CodigoMunicipio">- cód.:
                                            {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Endereco?.CodigoMunicipio}
                                        </div>
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-2 col-lg-2 col-xl-1">
                                    <label htmlFor="UF">
                                        UF
                                    </label>
                                    <span id="UF">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Endereco?.UF}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-3">
                                    <label htmlFor="CEP">
                                        CEP
                                    </label>
                                    <span id="CEP">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Endereco?.CEP}
                                    </span>
                                </div>

                                <div id="Credenciamento" className="uninter-diploma_digital-titulo_interno">
                                    Credenciamento
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-3">
                                    <label htmlFor="Tipo">
                                        Tipo
                                    </label>
                                    <span id="Tipo">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Credenciamento?.Tipo}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-3 col-lg-2 col-xl-2">
                                    <label htmlFor="Numero">
                                        Número
                                    </label>
                                    <span id="Numero">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Credenciamento?.Numero}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-4">
                                    <label htmlFor="Data">
                                        Data
                                    </label>
                                    <span id="Data">
                                        {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Credenciamento?.Data)}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-4">
                                    <label htmlFor="DataPublicacao">
                                        Data da Publicação
                                    </label>
                                    <span id="DataPublicacao">
                                        {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Credenciamento?.DataPublicacao)}
                                    </span>
                                </div>

                                <div id="Recredenciamento" className="uninter-diploma_digital-titulo_interno">
                                    Recredenciamento
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-3">
                                    <label htmlFor="Tipo">
                                        Tipo
                                    </label>
                                    <span id="Tipo">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Recredenciamento?.Tipo}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-3 col-lg-2 col-xl-2">
                                    <label htmlFor="Numero">
                                        Número
                                    </label>
                                    <span id="Numero">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Recredenciamento?.Numero}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-4">
                                    <label htmlFor="Data">
                                        Data
                                    </label>
                                    <span id="Data">
                                        {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Recredenciamento?.Data)}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-4">
                                    <label htmlFor="DataPublicacao">
                                        Data da Publicação
                                    </label>
                                    <span id="DataPublicacao">
                                        {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Recredenciamento?.DataPublicacao)}
                                    </span>
                                </div>

                                <div id="Mantenedora" className="uninter-diploma_digital-titulo_interno">
                                    Mantenedora
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <label htmlFor="RazaoSocial">
                                        Razão Social
                                    </label>
                                    <span id="RazaoSocial" className="campo_responsivo-height">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Mantenedora?.RazaoSocial}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5">
                                    <label htmlFor="CNPJ">
                                        CNPJ
                                    </label>
                                    <span id="CNPJ">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Mantenedora?.CNPJ}
                                    </span>
                                </div>

                                <div id="EnderecoCurso" className="uninter-diploma_digital-titulo_interno">
                                    Endereço do Curso
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10">
                                    <label htmlFor="Logradouro">
                                        Logradouro
                                    </label>
                                    <span id="Logradouro" className="campo_responsivo-height">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Mantenedora?.Endereco?.Logradouro}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-3 col-lg-2 col-xl-2">
                                    <label htmlFor="Numero">
                                        Número
                                    </label>
                                    <span id="Numero">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Mantenedora?.Endereco?.Numero}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-6 col-xl-6">
                                    <label htmlFor="Bairro">
                                        Bairro
                                    </label>
                                    <span id="Bairro">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Mantenedora?.Endereco?.Bairro}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-6 col-xl-6">
                                    <label htmlFor="Municipio">
                                        Município
                                    </label>
                                    <span id="Municipio">
                                        <div id="NomeMunicipio">
                                            {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Mantenedora?.Endereco?.NomeMunicipio}
                                        </div>
                                        <div id="CodigoMunicipio">- cód.:
                                            {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Mantenedora?.Endereco?.CodigoMunicipio}
                                        </div>
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-4 col-sm-2 col-md-2 col-lg-2 col-xl-1">
                                    <label htmlFor="UF">
                                        UF
                                    </label>
                                    <span id="UF">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Mantenedora?.Endereco?.UF}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-6 col-lg-4 col-xl-3">
                                    <label htmlFor="CEP">
                                        CEP
                                    </label>
                                    <span id="CEP">
                                        {xmlJson?.Diploma?.infDiploma?.DadosDiploma?.IesEmissora?.Mantenedora?.Endereco?.CEP}
                                    </span>
                                </div>

                            </div>

                            <div className="uninter-diploma_digital-campos-box col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h3>Livro Registro</h3>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <label htmlFor="NumeroFolhaDoDiploma">
                                        Número Folha do Diploma
                                    </label>
                                    <span id="NumeroFolhaDoDiploma">
                                        {xmlJson?.Diploma?.infDiploma?.DadosRegistro?.LivroRegistro?.NumeroFolhaDoDiploma}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <label htmlFor="NumeroSequenciaDoDiploma">
                                        Número Sequência do Diploma
                                    </label>
                                    <span id="NumeroSequenciaDoDiploma">
                                        {xmlJson?.Diploma?.infDiploma?.DadosRegistro?.LivroRegistro?.NumeroSequenciaDoDiploma}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <label htmlFor="DataConclusaoCurso">
                                        Data Conclusão do Curso
                                    </label>
                                    <span id="DataConclusaoCurso">
                                        {HelperDate.formatOlyDate(diploma?.dataConclusao)}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <label htmlFor="DataColacaoGrau">
                                        Data Colacao de Grau
                                    </label>
                                    <span id="DataColacaoGrau">
                                        {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosRegistro?.LivroRegistro?.DataColacaoGrau)}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <label htmlFor="DataExpedicaoDiploma">
                                        Data Expedição do Diploma
                                    </label>
                                    <span id="DataExpedicaoDiploma">
                                        {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosRegistro?.LivroRegistro?.DataExpedicaoDiploma)}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <label htmlFor="DataRegistroDiploma">
                                        Data Registro do Diploma
                                    </label>
                                    <span id="DataRegistroDiploma">
                                        {HelperDate.formatOlyDate(xmlJson?.Diploma?.infDiploma?.DadosRegistro?.LivroRegistro?.DataRegistroDiploma)}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <label htmlFor="DataPublicacaoRegistro">
                                        Data Publicação do Registro em DOU
                                    </label>
                                    <span id="DataPublicacaoRegistro">
                                        {HelperDate.formatOlyDate(diploma?.registro?.dataPublicacaoRegistroDOU)}
                                    </span>
                                </div>

                                <div id="ResponsavelRegistro" className="uninter-diploma_digital-titulo_interno">
                                    Responsável Registro
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-12 col-md-10 col-lg-9 col-xl-9">
                                    <label htmlFor="Nome">
                                        Nome
                                    </label>
                                    <span id="Nome" className="campo_responsivo-height">
                                        {xmlJson?.Diploma?.infDiploma?.DadosRegistro?.LivroRegistro?.ResponsavelRegistro?.Nome}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-4 col-lg-4 col-xl-4">
                                    <label htmlFor="Matricula">
                                        Matricula
                                    </label>
                                    <span id="Matricula" className="campo_responsivo-height">
                                        {xmlJson?.Diploma?.infDiploma?.DadosRegistro?.LivroRegistro?.ResponsavelRegistro?.IDouNumeroMatricula}
                                    </span>
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-10 col-md-4 col-lg-4 col-xl-4">
                                    <label htmlFor="PortariaDesignacao">
                                        Portaria de Designação
                                    </label>
                                    <span id="PortariaDesignacao">
                                        {diploma?.registro?.portariaDesignacao}
                                    </span>
                                </div>

                            </div>

                            <div className="uninter-diploma_digital-campos-box col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h3>Informações Complementares</h3>
                                <div id="Seguranca" className="uninter-diploma_digital-titulo_interno">
                                    Segurança
                                </div>

                                <div className="uninter-diploma_digital-campos-form col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <label htmlFor="CodigoValidacao">
                                        Código Validação
                                    </label>
                                    <span id="CodigoValidacao" className="campo_responsivo-height">
                                        {xmlJson?.Diploma?.infDiploma?.DadosRegistro?.Seguranca?.CodigoValidacao}
                                    </span>
                                </div>

                            </div>

                        </>
                    }

                    {
                        (diploma?.anulacoes.length > 0 && !diploma?.anulado) &&
                        <div className="topo-dados_diploma-historico col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <button type="button" onClick={handleShowAnulacoes}>
                                Este Diploma tem um histórico de anulação, clique aqui para visualizar
                            </button>
                        </div>
                    }


                </div>

            </div>
        </div>
    );
};

export default DiplomaValidacao;